// Core
import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";

// Register necessary chart components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);

const LineChart = ({
  borderColor = "#12214F",
  backgroundColor = "rgba(18, 33, 79, 0.2)",
  pointBackgroundColor = "#5AC7FA",
  pointBorderColor = "#12214F",
  tension,
  xAxisColor,
  yAxisColor,
  chartData = {
    labels: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    datasets: [
      {
        label: "Data Points",
        data: [0, 0, 0, 0, 0, 0],
      },
    ],
  },
  width,
}) => {
  const data = {
    labels: chartData?.labels,
    datasets: [
      {
        label: chartData?.datasets?.[0]?.label,
        data: chartData?.datasets?.[0]?.data,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
        pointBackgroundColor: pointBackgroundColor,
        pointBorderColor: pointBorderColor,
        pointBorderWidth: 2,
        fill: false,
        tension: tension,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          color: yAxisColor,
        },
        border: {
          dash: [4, 4],
          display: false,
        },
      },
      x: {
        ticks: {
          display: true,
          color: xAxisColor,
        },
        grid: {
          display: false,
        },
        border: {
          dash: [4, 4],
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <div
      style={{
        maxWidth: "auto",
        width: { width },
        height: "282px",
        borderRadius: "20px",
        border: "solid black 1px",
        padding: "20px 10px 1px 35px",
      }}
    >
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
